/**
 * Whether a postponed case's reassessment has come round.
 *
 * Compared as plain yyyy-mm-dd strings on purpose. Both sides are calendar
 * days, and turning them into Date objects would drag in a timezone the
 * column does not have -- the tenant's timestamps are already naive, which is
 * exactly the trap istDateTime exists to keep out of code like this.
 */
export function isReviewDue(row, todayKey) {
  const due = row && row.next_review_date;
  if (!due || !todayKey) return false;
  return String(due) <= String(todayKey);
}
